// client/src/pages/ResetPassword.jsx
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabaseClient';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [stage, setStage] = useState('verifying');
  const [newPw, setNewPw] = useState('');
  const [msg, setMsg] = useState('');

  // read the search params only once on mount
  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get('token');
    const type = url.searchParams.get('type');
    const email = url.searchParams.get('email');

    if (type !== 'recovery' || !token) {
      setStage('error');
      setMsg('Invalid or missing recovery token.');
      return;
    }

    const verify = async () => {
      const { error } = await supabase.auth.verifyOtp({ token, type: 'recovery', email });
      if (error) {
        setStage('error');
        setMsg(error.message);
      } else {
        setStage('form');
      }
    };

    verify();
  }, []);

  const handleUpdate = async () => {
    if (newPw.length < 8) {
      setMsg('Please use at least 8 characters.');
      return;
    }
    const { error } = await supabase.auth.updateUser({ password: newPw });
    if (error) {
      setMsg(error.message);
    } else {
      setStage('done');
      setMsg('Password updated! Redirecting to login…');
      await supabase.auth.signOut();
      setTimeout(() => navigate('/'), 1500);
    }
  };

  const Wrapper = ({ children }) => (
    <div className="reset-wrapper">
      <div className="reset-card">{children}</div>
    </div>
  );

  if (stage === 'verifying') return <Wrapper><p>Verifying link…</p></Wrapper>;
  if (stage === 'error')     return <Wrapper><p className="auth-message">{msg}</p></Wrapper>;
  if (stage === 'done')      return <Wrapper><p className="auth-message">{msg}</p></Wrapper>;

  return (
    <Wrapper>
      <h2 className="reset-heading">Set New Password</h2>
      <input
        type="password"
        placeholder="New password"
        value={newPw}
        onChange={(e) => setNewPw(e.target.value)}
        className="auth-input"
        autoFocus
      
      />
      <button onClick={handleUpdate} className="auth-button">
        Update Password
      </button>
      {msg && <p className="auth-message">{msg}</p>}
    </Wrapper>
  );
}
